module.exports = [{
      plugin: require('/opt/build/repo/demo/node_modules/gatsby-plugin-theme-ui/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/opt/build/repo/demo/node_modules/gatsby-theme-contentful-portfolio/gatsby-browser.js'),
      options: {"plugins":[],"basePath":"/","baseTitle":"My recent work","siteMetadata":{"siteUrl":"localhost:8000","siteName":"Gatsby Theme Contentful Portfolio"},"contentfulOptions":{"spaceId":"vtsgb20rfw59","accessToken":"iN_nON52n1p_a1ine-nHRauYZN0aU0WnGqdHiP1wPXQ"}},
    },{
      plugin: require('/opt/build/repo/demo/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
